import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_OLD, offerIncludes, offerRows } from '../data/teatro';
import { REAL_MOCKUP as PRODUCT_IMAGE } from '../data/realImages';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-235" data-mp="1hofnzt3dn96h">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-236" data-mp="tyv6zfqsalzu">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-237" data-mp="u0ocgrpnv069">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-238" data-mp="p120ellkjpz1">
            Scopri il tuo pacchetto completo <em className="text-red-300" data-id="element-239" data-mp="13yc6fffg03nd">TEATRO PRONTO™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-240" data-mp="yx52jrgf7olz">
            Il tuo anno di teatro a scuola – 100% già pronto. Entra in aula con la recita già pronta.
          </p>
          {PRODUCT_IMAGE && <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-241" data-mp="2actocfhxuhl7" />}
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-242" data-mp="ujbme4l4m4w3">
          {PRODUCT_IMAGE && <img src={PRODUCT_IMAGE} alt="TEATRO PRONTO™: 6 volumi + 5 bonus" className="mx-auto mb-6 w-full max-w-[16rem] drop-shadow-xl lg:hidden" data-id="element-243" data-mp="zj6egbgn10iq" />}
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-244" data-mp="6u9896ppau6c">Il pacchetto completo contiene</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-245" data-mp="bsaq5obe4ng8">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-246" data-mp="fu5ocjy0ykps">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-247" data-mp="kl48jum4w2yb">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-248" data-mp="3k95k2ea7mxi6" />
                </span>
                <span data-id="element-249" data-mp="3o95xbvlkp2nn">
                  <span className="block font-medium leading-snug" data-id="element-250" data-mp="3o8o5rc9uvcm2">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-251" data-mp="vefu24hea925">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-252" data-mp="155af55iwn2m0">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-253" data-mp="106z6uz89d05w">
              Prezzo di lancio <span className="ml-1 text-slate-900/50" data-id="element-254" data-mp="cho1f4fyqhlf">invece di <s data-id="element-255" data-mp="7hryl8j04w7g">{PRICE_OLD}</s></span>
            </p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-256" data-mp="7j39dsav7482">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-257" data-mp="hg7oj86alzfd">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-258" data-mp="1ww6qg1pbgz76" />
            Pagamento unico. Nessun abbonamento.
          </p>

          <CtaButton label="Voglio il pacchetto completo" className="mt-8 w-full" data-id="element-259" data-mp="1sul8i1xxduq4" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-260" data-mp="20dm8id9ip68q">
            {offerIncludes.map(item => <li key={item} data-id="element-261" data-mp="25bnnalzwujee">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}